import React from 'react'
import { graphql } from 'gatsby'
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import StructuredText from "../custom-structured-text-renderer"
import { RightArrowSmall } from "../../icons"
import parse from "html-react-parser"

const KeepExploring = ({richContent, links, title, button, orangeDotButton}) => {

  return (
    <section className="keep-exploring">
      <div className='keep-exploring__inner'>
        <div className="keep-exploring__title">
          <div className="line line--horizon center-left"></div>

          {title && <h2>{parse(title)}</h2>}
          {orangeDotButton?.length > 0 && (<Link
            className="btn btn--orange"
            to={orangeDotButton[0].link[0].externalLink ? orangeDotButton[0].link[0].externalLink : orangeDotButton[0].link[0].internalLink.permalink}
          >
            {orangeDotButton[0].title}
          </Link>)}
        </div>

        <div className="keep-exploring__wrapper">
          <div className="line line--vertical center-bottom"></div>
          <div className="line line--vertical center-top"></div>
          <div className="line line--horizon center-right"></div>

          <div className="keep-exploring__items">
            <div className="keep-exploring__item">
              {richContent && <StructuredText data={richContent} />}
              { button?.length > 0 && <Link className="btn btn--border-white" {...button}>{button[0]?.title} <RightArrowSmall /></Link> }
            </div>

            {
              links?.length > 0 && links.map((el, i) => (
                <Link to={el.permalink} key={i} className="keep-exploring__item">
                  {el.image && <Asset asset={el.image} />}
                  {el.thumbnail && <Asset asset={el.thumbnail} />}
                  {el.bannerImage && <Asset asset={el.bannerImage} />}
                  {el.sectors?.length > 0 && <span>{el.sectors[0].title}</span>}
                  {el.categories?.length > 0 && <span>{el.categories[0].title}</span>}
                  {el.title && <h3>{parse(el.title)}</h3>}
                  <RightArrowSmall />
                </Link>
              ))
            }
          </div>
        </div>
      </div>
    </section>
  )
}

export default KeepExploring

export const query = graphql`
  fragment KeepExploringProps on DatoCmsKeepExploring {
    ... on DatoCmsKeepExploring {
      id
      title
      richContent {
        value
      }
      button {
        ...LinkWithTitleProps
      }
      orangeDotButton {
        ...LinkWithTitleProps
      }
      links {
        ... on DatoCmsProject {
          id
          permalink
          title
          subtitle
          sectors {
            title
          }
          thumbnail {
            ...InternalAssetProps
          }
        }
        ... on DatoCmsArticle {
          id
          bannerImage {
            ...InternalAssetProps
          }
          categories {
            title
          }
          permalink
          title
        }
        ... on DatoCmsService {
          id
          image {
            ...InternalAssetProps
          }
          title
          permalink
        }
      }
    }
  }
`;